import React, { Component } from 'react';
import {Paper, Grid, Typography, TextField, Button} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
// import Settings from '@material-ui/icons/Settings';
import DatasheetView from './DatasheetView';

export default class RomList extends Component {

    constructor(props) {
        super(props);
        this.initial_state = {
            empl_num_error: null,
            empl_num_input: '',
            name_error: null,
            name_input: '',
            can_submit: false,
            registering: false,
            error: false,
            error_message: '',
            querying: true,
            roms_array: [],
            show_dialogue: false,
        }
        this.state = this.initial_state;
        this.datasheetFieldSpecs = [
            { field: 'id', headerName: 'Empl. #', width: 90, sortable:false},
            { field: 'name', headerName: 'Name', width: 160},
            { field: 'job_title', headerName: 'Position', width: 160},
            { field: 'region', headerName: 'Region', width: 110},
            { field: 'rom_code', headerName: 'Code', width: 80},
        ]
    }

    componentDidMount = () => {
      Gserv.sendCommand('query_roms',this.props.gwt)
      .then(reply=>{
        // console.log('reply :>> ', reply);
        if (reply.error){
            console.log('error on return from Gserv (query_roms) :>> ', reply);
            this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
        } else if (reply.Result!=="Success"&&reply.statusCode!==204){
            console.log('error on return from Gserv (query_roms) :>> ', reply);
            this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
        } else {
            this.setState({querying:false, roms_array:reply.Records?reply.Records : []});
        }

      });
    };

    handleDelete = (record) => {
        // console.log('record for delete :>> ', record);

        // this.setState({show_dialogue:true});
        //Hide just while testing modal...
        this.setState({registering:true,querying:true});
        Gserv.sendCommand('delete_rom',this.props.gwt,{
            employee_number: record.id
        })
        .then(reply => {
            // console.log('delete reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (delete_rom) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"){
                console.log('error on return from Gserv (delete_rom) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                this.setState(this.initial_state);
                this.componentDidMount();
            }
        });

    }
    
    resetMe = () => {
        this.setState(this.initial_state);
        this.componentDidMount();
    }

    submitHandler = (e) => {
        e.preventDefault();
        // console.log('e :>> ', e);
        this.setState({can_submit:false, registering:true});
        Gserv.sendCommand('designate_rom',this.props.gwt,{
            employee_number: this.state.empl_num_input,
            code: this.state.name_input
        })
        .then(reply => {
            // console.log('reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (designate_rom) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
            } else if (reply.Result!=="Success"&&reply.statusCode!==200&&reply.statusCode!==404&&reply.statusCode!==409){
                console.log('error on return from Gserv (designate_rom) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
            } else if (reply.Result!=="Success"){
                //not broken, but for some reason couldn't update / add record
                if (reply.Message.includes('employee already designated')){
                    this.setState({error:true,error_message:"This employee is already designated as a Manager using the code provided."});
                } else if (reply.Message.includes('employee record not found')) {
                    this.setState({error:true,error_message:"No employee found with specified employee number."});
                } else if (reply.Message.includes('duplicate rom code')) {
                    this.setState({error:true,error_message:"This Manager Code is already assigned to another employee."});
                } else {
                    this.setState({error:true,error_message:"Unable to designate selected employee as a Manager."})
                }
            } else {
                this.setState(this.initial_state);
                this.componentDidMount();
            }
        });
    }

    render() {
        return (
            <Grid
                container
                direction='column'
                justifyContent='center'
                alignContent='center'
                // style={{backgroundColor:'yellow'}}
            >
                
                <Grid item>
                <Paper
                    elevation={3}
                    style={{
                        // backgroundColor:'yellow',
                        // height:'22vh',
                        maxWidth:680
                    }}
                >
                   <Typography
                    color='primary'
                    style={{paddingTop:10}}
                   >
                       Designate Employee as a Manager:
                   </Typography>
                   <Grid
                    container
                    direction='row'
                    justifyContent='space-evenly'
                    alignContent='center'
                    style={{padding:15}}
                   >
                       <form onSubmit={this.submitHandler}>
                            <TextField
                                // color='primary'
                                autoComplete="off"
                                autoCorrect="off"
                                autoCapitalize="on"
                                autoFocus={false}
                                inputProps={{maxLength: 10 }}
                                error={this.state.empl_num_error}
                                // id="filled-error-helper-text"
                                label={'Employee Number'}
                                // helperText={'Please enter your surname'}
                                variant='outlined'
                                // placeholder={this.state.said_switch ? 'South African ID Number' : 'E.g. Foreign Passport No.'}
                                value={this.state.empl_num_input}
                                onChange={(e) => {
                                    const outText = e.target.value.replace(/[^0-9a-zA-Z]+/g, '').toUpperCase();   
                                    const can_sub = (this.state.name_input.length >=3 && this.state.id_input && outText.length>0)
                                    this.setState({empl_num_input: outText, empl_num_error: false, can_submit:can_sub});
                                }}
                                required
                                disabled={this.state.registering}
                                // inputRef={(element) => {this.textInput=element}}
                            />
                            <TextField
                                // color='primary'
                                autoComplete="off"
                                autoCorrect="off"
                                autoCapitalize="on"
                                autoFocus={true}
                                inputProps={{maxLength: 4 }}
                                error={this.state.name_error}
                                // id="filled-error-helper-text"
                                label={'New Manager Code'}
                                // helperText={'Please enter your surname'}
                                variant='outlined'
                                // placeholder={this.state.said_switch ? 'South African ID Number' : 'E.g. Foreign Passport No.'}
                                value={this.state.name_input}
                                onChange={(e) => {
                                    const outText = e.target.value.replace(/[^ A-Za-z0-9]+/g, '').toUpperCase();
                                    const can_sub = (outText.length>=2 && this.state.empl_num_input)
                                    this.setState({name_input: outText, can_submit: can_sub, error: false});
                                }}
                                required
                                style={{marginBottom:'10px'}}
                                disabled={this.state.registering}
                                
                                // inputRef={(element) => {this.textInput=element}}
                            />
                            <Button
                                variant='contained'
                                color='primary'
                                type='submit'
                                disabled={!this.state.can_submit}
                            >
                                Designate and/or Update Manager Code
                            </Button>
                        </form>
                   </Grid>
                </Paper>
                </Grid>
                <Grid item>
                    <Typography color='secondary' style={{maxWidth:680, textAlign:'center'}}>{this.state.error_message}</Typography>
                    {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
                </Grid>

                {/* {this.state.querying&&
                <Grid item>
                    <br/>
                    <Settings className='icn-spinner' /> Querying...
                </Grid>} */}

                {/* Datagrid goes here */}
                <DatasheetView 
                    dataset={this.state.roms_array}
                    fieldspecs={this.datasheetFieldSpecs}
                    delete={true}
                    edit={false}
                    handleDelete={this.handleDelete}
                    handleEdit={null}
                    loading={this.state.querying}
                    deleteHeaderName={'Delete'}
                    pagesize={8}
                />
            </Grid>
        );
    }
    
}